import { useState } from "react";
import { ImageOff } from "lucide-react";
import { cn } from "@/lib/utils";

export default function FileThumb({ src, alt, className }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <div className={cn("flex items-center justify-center bg-slate-50 text-slate-300", className)}>
        <ImageOff className="h-6 w-6" />
      </div>
    );
  }
  return <img src={src} alt={alt} onError={() => setFailed(true)} className={cn("object-cover", className)} />;
}
